module.exports = __webpack_public_path__ + "img/couponE_en.74f24ee2.png";